unit DepartmentItemListType;
{

/* Initail. */

}
interface

uses
  JS,
  DepartmentItemType;

type
  TDepartmentItemArray = array of TDepartmentItemType;

  TDepartmentItemListType = class
    fDepartmentItemArray: TDepartmentItemArray;
  public
    property DepartmentItemArray: TDepartmentItemArray read fDepartmentItemArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TDepartmentItemListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    DepartmentItemType: TDepartmentItemType;
begin
  if String_JSON <> 'null' then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      DepartmentItemType := TDepartmentItemType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(DepartmentItemType, fDepartmentItemArray, High(fDepartmentItemArray));
    end;
  end;
end;

end.
